import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class InView extends Component {
    static propTypes = {
        as: PropTypes.string,
        rootMargin: PropTypes.string,
        root: PropTypes.oneOfType([undefined, PropTypes.node]),
        threshold: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),
        triggerOnce: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        children: PropTypes.node.isRequired,
    };

    static defaultProps = {
        as: 'div',
        rootMargin: '0px',
        root: undefined,
        threshold: 0.5,
        triggerOnce: false,
    };

    state = {
        inView: false,
    };

    componentDidUpdate(prevProps, prevState) {
        if (typeof window === 'undefined' || !window.IntersectionObserver) return;
        // If an IntersectionObserver option changed, reinit the observer
        const { rootMargin, root, threshold, triggerOnce } = this.props;
        const { inView } = this.state;
        if (prevProps.rootMargin !== rootMargin || prevProps.root !== root || prevProps.threshold !== threshold) {
            this.unobserveNode();
            this.observeNode();
        }

        if (prevState.inView !== inView) {
            if (inView && triggerOnce) {
                this.unobserveNode();
                this.node = null;
            }
        }
    }

    componentWillUnmount() {
        if (this.node) {
            this.unobserveNode();
            this.node = null;
        }
    }

    node = null;
    observer = null;
    pageLoad = true;

    observeNode = () => {
        if (!this.observer) {
            const { root, rootMargin, threshold } = this.props;
            this.observer = new IntersectionObserver(this.handleChange, {
                root,
                rootMargin,
                threshold,
            });
        }
        if (!this.node) return;
        this.observer.observe(this.node);
    };

    unobserveNode = () => {
        if (!this.node || !this.observer) return;
        this.observer.unobserve(this.node);
    };

    handleNode = (node) => {
        if (!node) return;
        this.node = node;
        this.observeNode();
    };

    handleChange = (entries) => {
        const { onChange } = this.props;
        const entry = entries[0];
        const inView = entry.isIntersecting;
        this.setState({ inView });
        if (onChange) {
            onChange({ entry, inView, trigger: this.pageLoad ? 'on_load' : 'on_scroll' });
        }
        this.pageLoad = false;
    };

    render() {
        const { children, as: Tag, triggerOnce, root, rootMargin, threshold, ...props } = this.props;

        return (
            <Tag ref={this.handleNode} {...props}>
                {children}
            </Tag>
        );
    }
}